import { ResultStream } from '@causality/core';
import { Campaign, FormMetadata } from '@formunauts/shared/campaigning/domain';
import {
  GetCampaignFormsMetadataError,
  GetSCOFormsMetadataError,
} from './form-meta-error.model';
import { FormMetadataRepository } from './form-meta-repository.model';

export const getCampaignFormsMetadata =
  (repo: FormMetadataRepository) =>
  (
    form_id: number,
    form_type: Campaign.FormType,
  ): ResultStream.ResultStream<FormMetadata, GetCampaignFormsMetadataError> =>
    repo.getCampaignFormsMetadata(form_id, form_type);

export const getSCOFormsMetadata =
  (repo: FormMetadataRepository) =>
  (
    hash: string,
  ): ResultStream.ResultStream<FormMetadata, GetSCOFormsMetadataError> =>
    repo.getSCOFormsMetadata(hash);
